module.exports = __webpack_public_path__ + "static/img/bg-secondary-banner-management.3f109d9e.png";